module.exports = {
    get: function(url, options) {
        return window.http.get(url, options).then(res => {
            return res.body
        });
    },
    post: function(url, options, config) {
        return window.http.post(url, options, config).then(res => {
            return res.body
        });
    }
}



// WEBPACK FOOTER //
// ./src/service/base.service.js